import axiosInstance from '../../../config/axiosInstance';
const JasperReportService = {
    async GetAllJasperReports(ModuleID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/GetAllJasperReports?ClientID=${ClientID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetJasperReportByID(ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/GetJasperReportByID?ClientID=${ClientID}&ID=${ID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteJasperReport(ReportID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/DeleteJasperReport?ReportID=${ReportID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching report details:', error);
            throw error;
        }
    },

    async CreateJasperReport(ReportID, inputValues) {
        try {
            const response = await axiosInstance.post(`/Dashboard/CreateJasperReport?ReportID=${ReportID}`, inputValues);
            return response.data;
        } catch (error) {
            console.error('Error executing report:', error);
            throw error;
        }
    },
    async getReportDetail(ReportID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/JasperReportDetail?ReportID=${ReportID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching report details:', error);
            throw error;
        }
    },
    async ProxyReport(queryObj) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            queryObj.ClientID = ClientID;
            queryObj.paramQuotationId = queryObj.ID;
            const queryParams = new URLSearchParams(queryObj).toString();

            const response = await axiosInstance.get(
                `/Dashboard/ProxyReport?${queryParams}`,
                { responseType: 'blob' }   // ✅ Important for PDF
            );

            return response;
        } catch (error) {
            console.error('Error fetching report details:', error);
            throw error;
        }
    }

};

export default JasperReportService;